import { render, staticRenderFns } from "./Tulora.vue?vue&type=template&id=b92a4ba2&"
import script from "./Tulora.vue?vue&type=script&lang=js&"
export * from "./Tulora.vue?vue&type=script&lang=js&"
import style0 from "./Tulora.vue?vue&type=style&index=0&id=b92a4ba2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports